import { Radio } from 'antd';
import styled from 'styled-components';

export const RadioWrapper = styled(Radio)``;
